<template>
    <div class="full-height">
        <v-container class="blue-bg">
            <v-banner>
                <v-img :src="require('./../assets/banner1.jpg')"></v-img>
            </v-banner>
            <v-row class="dark-blue-bg" @click="openOffice">
                <v-col cols="12">
                    <v-img :src="require('./../assets/mydha.png')" contain height="50"></v-img>
                </v-col>
            </v-row>
            <v-row class="pa-5">
                <v-col cols="12" lg="6" md="6" v-for="tab in tabs" :key="tab.title">
                    <v-list-item :href="`https://`+tab.link">
                        <v-list-item-avatar>
                            <v-img :src="require('./../assets/'+tab.imgpath+'')"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="white--text grey-border">
                            <v-list-item-title class="roboto-text">{{tab.title}}</v-list-item-title>
                            <v-list-item-subtitle class="grey--text opensans-text">
                                {{tab.subtitle}}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="12" lg="6" md="6">
                    <v-list-item :href="`https://vuldha.com/payment/fall`">
                        <v-list-item-avatar color="white" class="pa-1">
                            <v-img :src="require('./../assets/payment-info.png')" contain></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="white--text grey-border">
                            <v-list-item-title class="roboto-text">Fall 2026 Semester Tuition Payment</v-list-item-title>
                            <v-list-item-subtitle class="grey--text opensans-text">
                                Fill in the details to pay fee online
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="12" lg="6" md="6">
                    <v-list-item :href="`https://vuldha.com/payment/spring`">
                        <v-list-item-avatar color="white" class="pa-1">
                            <v-img :src="require('./../assets/payment-info.png')" contain></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="white--text grey-border">
                            <v-list-item-title class="roboto-text">Spring 2027 Semester Tuition Payment</v-list-item-title>
                            <v-list-item-subtitle class="grey--text opensans-text">
                                Fill in the details to pay fee online
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="12" lg="6" md="6">
                    <v-list-item :href="`https://connect.vul.edu/register/financial-contract`">
                        <v-list-item-avatar color="white" class="pa-1">
                            <!-- <v-icon color="#0b295f">mdi-file-document</v-icon> -->
                            <v-img :src="require('./../assets/financial-contract.png')" contain></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="white--text grey-border">
                            <v-list-item-title class="roboto-text">Financial Contract for New Students Starting in Spring 2027 Semester</v-list-item-title>
                            <v-list-item-subtitle class="grey--text opensans-text">
                                Fill in the form online
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="12" lg="6" md="6">
                    <v-list-item :href="`https://connect.vul.edu/register/student-enrollment-agreement`">
                        <v-list-item-avatar color="white" class="pa-1">
                            <v-img :src="require('./../assets/financial-contract.png')" contain></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="white--text grey-border">
                            <v-list-item-title class="roboto-text">Student Enrollment Agreement for New Students Starting in Spring 2027 Semester</v-list-item-title>
                            <v-list-item-subtitle class="grey--text opensans-text">
                                Fill in the form online
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="12" lg="6" md="6">
                    <v-list-item :href="`https://pubmed.ncbi.nlm.nih.gov/`">
                        <v-list-item-avatar color="white">
                            <v-img :src="require('./../assets/pubmedlogo.png')"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="white--text grey-border">
                            <v-list-item-title class="roboto-text">PubMed Database</v-list-item-title>
                            <v-list-item-subtitle class="grey--text opensans-text">
                                Access citations and abstracts
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="12" lg="6" md="6">
                    <v-list-item :href="`https://vul.edu/commencement`">
                        <v-list-item-avatar color="white">
                            <v-img :src="require('./../assets/graduation-ceremony.png')" contain></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="white--text grey-border">
                            <v-list-item-title class="roboto-text">2026 Commencement Ceremony</v-list-item-title>
                            <v-list-item-subtitle class="grey--text opensans-text">
                                Get latest information for 2026 Commencement Ceremony.
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="12" lg="6" md="6">
                    <v-list-item :href="`https://vuldha.com/graduationfee/pay`">
                        <v-list-item-avatar color="white" class="pa-1">
                            <v-img :src="require('./../assets/payment-info.png')" contain></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="white--text grey-border">
                            <v-list-item-title class="roboto-text">Graduation Fee Payment</v-list-item-title>
                            <v-list-item-subtitle class="grey--text opensans-text">
                                Fill in the details to pay fee online
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="12" lg="6" md="6">
                    <v-list-item :href="`https://www.parchment.com/u/registration/3043858/institution`">
                        <v-list-item-avatar color="white" class="">
                            <v-img :src="require('./../assets/online_order.jpg')" contain></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="white--text grey-border">
                            <v-list-item-title class="roboto-text">Request Transcript</v-list-item-title>
                            <v-list-item-subtitle class="grey--text opensans-text">
                                Order your transcripts online
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="12" lg="6" md="6">
                    <v-list-item :href="`https://vuldha.com/support/ticket/create`">
                        <v-list-item-avatar color="white" class="">
                            <v-img :src="require('./../assets/message.png')" contain></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="white--text grey-border">
                            <v-list-item-title class="roboto-text">Student Communication Management</v-list-item-title>
                            <v-list-item-subtitle class="grey--text opensans-text">
                                Post your query here
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                loginLink: 'https://login.microsoftonline.com/common/oauth2/authorize?client_id=4345a7b9-9a63-4910-a426-35363201d503&redirect_uri=https%3A%2F%2Fwww.office.com%2Flanding&response_type=code%20id_token&scope=openid%20profile&response_mode=form_post&nonce=637342346910181791.YmVlMWJmMWItODlhNi00YzBmLWIxY2UtNWEwZmU1OWIzYTQ5NWJlOTc1M2YtYzYyZC00MWE5LTllYTItNjQ1OGQ4NDRjNjg2&ui_locales=en-US&mkt=en-US&client-request-id=cb453a57-0602-457c-baa7-4eb72bf3e85f&state=czyRcLH9s6KGzQ8otMF2jAfVo5UB4wHOvrP9dLnx7VKWTI8ufjnAz5Id8d6VAIHli-q9z0C5jY20YqhwaED5J2tb4Ga5fAcel6lTsnrRSfcZU-rMt9E8nRirqZao9r2HA53JZkdg6NdSOCkm2aD2Dos4ZzCT56hCqPck80_tWnP0CLpC8_3n9m9jmmeN_lYypFc3epnWtTRbi5HSC9ckYuGb2bf9CpWTHVByj0jYDyA6JASlT9uYOhcosk_zAMmVxAfUdjh8kWlhqEXkqReTbQ&x-client-SKU=ID_NETSTANDARD2_0&x-client-ver=6.6.0.0',
                tabs: [
                    {
                        title: 'Virginia University of Lynchburg Home Page',
                        subtitle: 'The web home page of Virginia University of Lynchburg',
                        link: 'www.vul.edu/dha',
                        imgpath: 'vul.png'
                    },
                    {
                        title: 'Moodle Access for First Semester',
                        subtitle: 'Online Course Management System',
                        link: 'moodle-dha.vul.edu',
                        imgpath: 'moodle.gif'
                    },
                    {
                        title: 'Moodle Access for Second Semester',
                        subtitle: 'Online Course Management System',
                        link: 'moodle.vul.edu',
                        imgpath: 'moodle.gif'
                    },
                    {
                        title: 'Moodle Access for Third Semester',
                        subtitle: 'Online Course Management System',
                        link: 'moodle.vul.edu',
                        imgpath: 'moodle.gif'
                    },
                    {
                        title: 'Student Account Portal',
                        subtitle: 'Access student records',
                        link: 'secure.webconnectgradpro.com/vul/authenticate.php',
                        imgpath: 'student.jpg'
                    },
                    {
                        title: 'Business Source Complete',
                        subtitle: 'Login using VUL email account credentials and use the resources at the Virginia University of Lynchburg library.',
                        link: 'search.ebscohost.com/login.aspx?authtype=sso&custid=s2637754&groupid=main&profile=ehost',
                        //link: 'search.ebscohost.com/login.aspx?authtype=ip,uid&user=vullibrary&password=seminary@hill20&custid=s2637754&groupid=main&profile=ehost&defaultdb=bth',
                        imgpath: 'books.gif'
                    }
                ]
            }
        },
        methods:{
            openOffice(){
                window.open(this.loginLink);
            }
        }
    }
</script>

<style scoped>
    .blue-bg{
        background-color: #0b295f;
    }
    .dark-blue-bg{
        background-color: #091f47;
        cursor: pointer;
    }
    .opensans-text{
        font-family: 'Open Sans';
    }
    .roboto-text{
        font-family: 'Roboto';
    }
    .grey-border{
        border-color: #6b6b6b !important;
        border-bottom: 1px solid;
    }
    .v-list-item__title, .v-list-item__subtitle{
        text-overflow: clip !important;
        white-space: inherit !important;
    }
    .full-height{
        background-color: #eddfd4;
    }
</style>